var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.992,
    cy: 15.43,
    rx: 3.5,
    ry: 3.429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.965 2.173l1.031 3.319c.352 1.144 1.55 1.825 2.74 1.556l3.434-.78c1.336-.294 2.713.298 3.396 1.461.682 1.164.512 2.627-.421 3.61l-2.406 2.539c-.833.877-.833 2.236 0 3.113l2.406 2.54c.935.982 1.107 2.447.424 3.611-.683 1.165-2.062 1.757-3.399 1.46l-3.435-.781c-1.187-.26-2.38.417-2.739 1.556l-1.031 3.31c-.394 1.286-1.602 2.167-2.973 2.167-1.37 0-2.58-.88-2.973-2.167l-1.031-3.321c-.359-1.14-1.552-1.817-2.74-1.557l-3.434.782c-1.337.297-2.716-.296-3.399-1.46-.683-1.165-.51-2.63.424-3.612l2.406-2.54c.833-.877.833-2.235 0-3.112l-2.406-2.54c-.933-.983-1.103-2.446-.42-3.61.682-1.162 2.059-1.755 3.395-1.46l3.435.78c1.189.269 2.387-.412 2.739-1.557l1.031-3.319C11.415.876 12.626-.003 13.996 0c1.371.003 2.578.886 2.969 2.173z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.173a9ee33e3d7af830b120fa7506c712.svg";
export { ForwardRef as ReactComponent };